import { z } from "zod";
/**
 * Web notifications (plan feature `web_notifications`, Admin → «Notificaciones»).
 *
 * The events a school can be notified of. The DB keeps the same strings in a
 * VarChar + CHECK (`notifications.type`), so adding one is a CHECK change plus
 * an entry here.
 *
 * `lead_message` is not one of the «Notificaciones» switches: it is sent only
 * under «Avisar solo a partir del handoff» (WhatsApp page), for a customer who
 * writes while a person is responsible for the chat.
 */
export const NOTIFICATION_TYPES = [
    "order_confirmed",
    "quote_requested",
    "lead_handoff",
    "lead_message",
];
/**
 * `PUT /crm/notifications/settings` — any subset of the four switches. Partial
 * so each one saves the moment it is flipped, strict so a typo is a 400 rather
 * than a silent no-op (the `updateLeadAssignmentPolicySchema` shape).
 */
export const updateNotificationSettingsSchema = z
    .object({
    orderConfirmed: z.boolean().optional(),
    quoteRequested: z.boolean().optional(),
    leadHandoff: z.boolean().optional(),
    notifyAdmins: z.boolean().optional(),
})
    .strict()
    .refine((v) => Object.keys(v).length > 0, "Indica al menos una opción");
/** `PUT /crm/whatsapp/handoff-only-notifications`. */
export const updateHandoffOnlyPhoneNotificationsSchema = z
    .object({ enabled: z.boolean() })
    .strict();
/** `POST /crm/notifications/seen` — everything created up to this instant. */
export const markNotificationsSeenSchema = z.object({ upTo: z.string().datetime() }).strict();
/**
 * `POST /crm/notifications/push-subscriptions` — `PushSubscription.toJSON()`.
 * Bounded because it is stored as-is; real endpoints are a few hundred chars.
 */
export const webPushSubscriptionSchema = z.object({
    endpoint: z.string().url().max(2048),
    keys: z
        .object({
        p256dh: z.string().min(1).max(255),
        auth: z.string().min(1).max(255),
    })
        .strip(),
});
/** `DELETE /crm/notifications/push-subscriptions`. */
export const deleteWebPushSubscriptionSchema = z
    .object({ endpoint: z.string().url().max(2048) })
    .strict();
/**
 * The CRM path a notification opens. RELATIVE on purpose: the service worker
 * resolves it against its own origin, so a push opens the right domain for
 * either brand without the backend knowing which one the browser is on.
 */
export function notificationPath(n) {
    if (n.type === "order_confirmed" && n.orderId)
        return `/pedidos/${n.orderId}`;
    if (n.type === "quote_requested" && n.quoteId)
        return `/cotizaciones/${n.quoteId}`;
    return `/leads/${n.leadId}`;
}
//# sourceMappingURL=notifications.js.map